import { useNavigate, useSearchParams, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AppContext";
import { AuthPanel } from "@/components/AuthPanel";
import { useSeo } from "@/lib/draft";

export default function Entrar() {
  useSeo("Entrar", null, true);
  const [p] = useSearchParams();
  const next = p.get("next") || "/minhas-solicitacoes";
  const nav = useNavigate();
  const { user } = useAuth();
  if (user && user.role === "admin") return <Navigate to="/admin" replace />;
  if (user) return <Navigate to={user.role === "lawyer" ? "/advogado" : next} replace />;
  return (
    <div className="wrap max-w-lg py-12">
      <h1 className="text-3xl font-extrabold" data-testid="login-title">Acesse sua área</h1>
      <p className="mb-6 mt-2 text-[#64748B]">Acompanhe suas solicitações e protocolos.</p>
      <div className="card"><AuthPanel initialTab="login" returnPath={next} onDone={(u) => nav(u.role === "lawyer" ? "/advogado" : next)} /></div>
    </div>
  );
}
